// extracted by mini-css-extract-plugin
export default {"message":"MessageDialog_message__MkqCU","actions":"MessageDialog_actions__NTpFi","btn":"MessageDialog_btn__-zlWV"};